import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { API } from '../App';
import { ONPREM } from '../edition';

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#0f0f1a',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    gap: '24px',
  },
  logo: {
    color: '#e94560',
    fontSize: '42px',
    fontWeight: 'bold',
    letterSpacing: '3px',
  },
  subtitle: {
    color: '#a0a0b0',
    fontSize: '14px',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    marginTop: '-16px',
  },
  card: {
    backgroundColor: '#16213e',
    borderRadius: '16px',
    padding: '40px',
    width: '100%',
    maxWidth: '460px',
    boxSizing: 'border-box',
  },
  title: {
    color: '#ffffff',
    fontSize: '22px',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  cardSubtitle: {
    color: '#a0a0b0',
    fontSize: '14px',
    marginBottom: '32px',
  },
  label: {
    color: '#a0a0b0',
    fontSize: '13px',
    marginBottom: '8px',
    display: 'block',
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    backgroundColor: '#0f3460',
    border: '1px solid #0f3460',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '16px',
    marginBottom: '20px',
    boxSizing: 'border-box',
    outline: 'none',
  },
  button: {
    width: '100%',
    padding: '16px',
    backgroundColor: '#e94560',
    border: 'none',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '8px',
    boxSizing: 'border-box',
  },
  error: {
    color: '#e94560',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  registerLink: {
    color: '#a0a0b0',
    fontSize: '14px',
    textAlign: 'center',
    marginTop: '24px',
  },
  link: {
    color: '#e94560',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleLogin() {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError('Invalid email or password');
      } else if (data.role !== 'admin' && data.role !== 'manager') {
        setError('Admin or manager access required');
      } else {
        localStorage.setItem('admin_token', data.token);
        localStorage.setItem('admin_name', data.name);
        localStorage.setItem('admin_role', data.role);
        // New/unsubscribed (or lapsed) admins go straight to Billing to pick a plan.
        if (data.role === 'admin') {
          try {
            const sres = await fetch(`${API}/billing/status`, {
              headers: { Authorization: `Bearer ${data.token}` },
            });
            if (sres.ok) {
              const s = await sres.json();
              navigate(s.access_state === 'full' ? '/dashboard' : '/billing');
              return;
            }
          } catch { /* fall through to dashboard */ }
        }
        navigate('/dashboard');
      }
    } catch (e) {
      setError('Could not connect to server');
    }
    setLoading(false);
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') handleLogin();
  }

  return (
    <div style={styles.container}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: '20px 24px',
        marginBottom: '32px',
        width: '300px',
      }}>
        <img src="/logo.png" alt="EZ Pace" style={{ width: '100%', display: 'block' }} />
      </div>
      <div style={styles.subtitle}>Admin Dashboard</div>
      <div style={styles.card}>
        <div style={styles.title}>Sign In</div>
        <div style={styles.cardSubtitle}>Access your casino management dashboard</div>
        {error && <div style={styles.error}>{error}</div>}
        <label style={styles.label}>Email</label>
        <input
          style={styles.input}
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="admin@yourcasino.com"
          autoCapitalize="none"
        />
        <label style={styles.label}>Password</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="••••••••"
        />
        <button style={styles.button} onClick={handleLogin} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <div style={styles.registerLink}>
          <Link to="/forgot-password" style={styles.link}>Forgot your password?</Link>
        </div>
        {!ONPREM && (
          <div style={styles.registerLink}>
            New casino? <Link to="/register" style={styles.link}>Create an account</Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminLogin;